import { gql } from '@/utils/graphql';

import alertFields from './alert';
import contentSeoFields from './content-seo';
import editPreviewFields from './edit-preview-fields';
import { imagefragment } from './image';
import languageFields from './language';
import translationsFields from './translations';

export const artistFragment = gql`
fragment artistFragment on Artist {
	id: databaseId
	title(format: RENDERED)
	blocksJSON
	uri
	${alertFields}
	artistCategories {
		nodes {
			name
		}
	}
	featuredImage {
		node {
			...imageFragment
			caption
		}
	}
	${alertFields}
	${editPreviewFields}
	${languageFields}
	${translationsFields}
	${contentSeoFields}
}
${imagefragment}
`;
